import { useTranslations } from 'use-intl';

import { CompanyDocumentType, IndividualDocumentType } from '@blockpulse3/graphql/hooks';

import { IdentityDocumentsSelectProps } from './types';

export const useGetKybDocuments = (): [(signerName?: string) => IdentityDocumentsSelectProps[]] => {
  const i18nIdentityValidationModal = useTranslations('IdentityValidationModal');

  return [
    (signerName?: string): IdentityDocumentsSelectProps[] => [
      {
        label: i18nIdentityValidationModal('DBE'),
        value: 'dbe',
        type: CompanyDocumentType.DBE,
      },
      {
        label: i18nIdentityValidationModal('STATUTS'),
        value: 'status',
        type: CompanyDocumentType.STATUTS,
      },
      {
        label: i18nIdentityValidationModal('REGISTER_EXTRACT'),
        value: 'registerExtract',
        type: CompanyDocumentType.REGISTER_EXTRACT,
      },
      {
        label: i18nIdentityValidationModal('IDENTITY_DOCUMENT', {
          name: signerName || '[représentant légal]',
        }),
        value: 'identityDocument',
        type: IndividualDocumentType.IDENTITY_DOCUMENT,
      },
      {
        label: i18nIdentityValidationModal('IDENTITY_DOCUMENT_SECONDARY', {
          name: signerName || '[représentant légal]',
        }),
        value: 'identityDocumentSecondary',
        type: IndividualDocumentType.IDENTITY_DOCUMENT_SECONDARY,
      },
    ],
  ];
};

export const useGetCompanyDocuments = (): [() => IdentityDocumentsSelectProps[]] => {
  const i18nIdentityValidationModal = useTranslations('IdentityValidationModal');

  return [
    (): IdentityDocumentsSelectProps[] => [
      {
        label: i18nIdentityValidationModal('DBE'),
        value: 'dbe',
        type: CompanyDocumentType.DBE,
      },
      {
        label: i18nIdentityValidationModal('STATUTS'),
        value: 'status',
        type: CompanyDocumentType.STATUTS,
      },
      {
        label: i18nIdentityValidationModal('REGISTER_EXTRACT'),
        value: 'registerExtract',
        type: CompanyDocumentType.REGISTER_EXTRACT,
      },
    ],
  ];
};

export const useGetKycDocuments = (): [(name?: string) => IdentityDocumentsSelectProps[]] => {
  const i18nIdentityValidationModal = useTranslations('IdentityValidationModal');

  return [
    (name?: string): IdentityDocumentsSelectProps[] => [
      {
        label: i18nIdentityValidationModal('IDENTITY_DOCUMENT', { name }),
        value: 'identityDocument',
        type: IndividualDocumentType.IDENTITY_DOCUMENT,
      },
      {
        label: i18nIdentityValidationModal('IDENTITY_DOCUMENT_SECONDARY', { name }),
        value: 'identityDocumentSecondary',
        type: IndividualDocumentType.IDENTITY_DOCUMENT_SECONDARY,
      },
    ],
  ];
};
